/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

/* eslint-disable max-len */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../components/GrayPanel';
import RodoContent from '../../components/RodoContent';
import AttachmentsPanel from '../../components/AttachmentsPanel';
import { connect } from 'react-redux';
import { runService } from '../../actions/eservices';
import PowrotDoListyEuslug from '../../components/PowrotDoListyEuslug';
import { isMobileView, isTabletView, renderHelpDesc, scrollToSection } from '../../components/utils/utils';
import EmptyFileDownloader from '../../components/EmptyFileDownloader';
import { PanelStyle } from '../../constants';
import { DecisionContainer, PersonalDataContainer } from '../../containers';
import CustomizedMap from './CustomizedMap';
import history from '../../core/history';
import s from './EServices.css';
import pans from './panStyle.scss';
import ModalAlert from './ModalAlert';
import _ from 'lodash';
import fetch from '../../core/fetch';
import agentConfig from './agent';
import loadingData from './loading';

import v from './validators';

const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


const btnStyle = {
  borderRadius: 0,
  border: 'none',
  padding: '10px 40px',
  marginLeft: '10px',
};

const infoDict = {
  zmiana_z: {
    label: 'Zmiana przeznaczenia z',
    editable: true,
    type: 'textarea',
    rows: 3
  },
  przeznaczenie: {
    label: 'Proponowane przeznaczenie',
    editable: true,
    type: 'textarea',
    rows: 3
  },
  uzasadnienie: {
    label: 'Uzasadnienie',
    editable: true,
    type: 'textarea',
    rows: 10
  },
};

const infoDict2 = {
  zmiana_z: {
    label: 'Obecne przeznaczenie',
    editable: true,
  },
  przeznaczenie: {
    label: 'Wnioskowane przeznaczenie',
    editable: true,
  },
};

const infoDict3 = {
  miejscowosc: {
    label: 'Miejscowość',
    editable: true,
  },
  przeznaczenie: {
    label: 'Opis zmiany (opisać wnioskowane przeznaczenie np. mieszkaniowe, usługowe z zakresu: handlu, gastronomii, rzemiosła - z określeniem rodzaju produkcji; przemysłowe – z określeniem rodzaju działalności przemysłowej; letniskowe, pod zalesienie, itp.)',
    editable: true,
    type: 'textarea',
  },
  uzasadnienie: {
    label: 'Uzasadnienie zmiany przeznaczenia',
    editable: true,
    type: 'textarea',
  },
};

const customInfoDict = {
  miejscowosc: {
    label: 'Miejscowość działek',
    editable: true,
  },
  przeznaczenie: {
    label: 'Proponowane przeznaczenie',
    editable: true,
  },
};

const mpzpOwnerDict = {
  FirstName: {
    label: 'Imię',
    editable: true,
  },
  LastName: {
    label: 'Nazwisko',
    editable: true,
  },
  CompanyName: {
    label: 'Firma',
    editable: true,
  },
  AddressCity: {
    label: 'Miejscowość',
    editable: true,
  },
  AddressStreet: {
    label: 'Ulica',
    editable: true,
  },
  AddressNumber: {
    label: 'Numer budynku',
    editable: true,
  },
  AddressFlat: {
    label: 'Numer lokalu',
    editable: true,
  },
  AddressZipCode: {
    label: 'Kod pocztowy',
    editable: true,
  },
};

class ZmianaMPZP extends React.Component {
  state = {
    mpzpOwner: {
      FirstName: null,
      LastName: null,
      CompanyName: null,
      AddressCity: null,
      AddressStreet: null,
      AddressNumber: null,
      AddressFlat: null,
      AddressZipCode: null,
    },
    info: {
      zmiana_z: null,
      przeznaczenie: null,
      uzasadnienie: null,
      miejscowosc: null,
      agentAdd: 'NIE',
      agentName: null,
      agentAddress: null,
      agentPostOffice: null,
      agentPostalCode: null,
      agentPhoneNumber: null,
      agentMotionAddress: null,
    },
    selectedParcels: [],
    selectedRoads: [],
    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,
    eserviceDistrict: null,
    attachments: null,
    loading: false,
    isMounted: false,
  };

  elseString = '.....................';
  spanStyle = {
    color: 'red',
  };

  validators = {
    FirstName: [v.NotNull],
    LastName: [v.NotNull],
    AddressCity: [v.NotNull, v.MinLength(2)],
    AddressStreet: [],
    AddressNumber: [v.NotNull],
    AddressZipCode: [v.NotNull],
    przeznaczenie: [],
    uzasadnienie: [],
    miejscowosc: [],
  };

  nextStep = '/eservices/eserviceSummary/';

  componentDidMount() {
    fetch(`${process.env.API_URL}/eservice/${this.props.district}/${this.props.query.serviceType}`)
      .then(r => r.json())
      .then(resp => {
        this.setState({
          eserviceDistrict: resp,
        }, () => this.updateValidators());
      });

    this.setState({ isMounted: true });
  }

  updateValidators = () => {
    if (this.props.prefix === 'gmina_olesno_powiat_oleski' || (this.state.eserviceDistrict && this.state.eserviceDistrict.custom)) {
      this.validators.FirstName = [];
      this.validators.LastName = [];
      this.validators.AddressCity = [];
      this.validators.AddressStreet = [];
      this.validators.AddressFlat = [];
      this.validators.AddressNumber = [];
      this.validators.AddressZipCode = [];
      this.validators.przeznaczenie = [v.NotNull];
      this.validators.uzasadnienie = [v.NotNull];
      this.validators.miejscowosc = [v.NotNull];
      if (this.state.eserviceDistrict && this.state.eserviceDistrict.custom) {
        this.validators.uzasadnienie = [];
        this.validators.zmiana_z = [];
      }
    }

    if (this.props.prefix !== 'gmina_olesno_powiat_oleski' && (this.state.eserviceDistrict && !this.state.eserviceDistrict.custom)) {
      this.validators.przeznaczenie = [v.NotNull];
      this.validators.uzasadnienie = [v.NotNull];
      this.validators.zmiana_z = [v.NotNull];
    }

    if (this.props.prefix === 'hrubieszow') {
      this.validators.uzasadnienie = [];
    }
  }

  onHide = () => this.setState({ showError: false });

  setParcels = (parcels, callback = null) => this.setState({ selectedParcels: parcels });
  setRoads = (roads, callback = null) => this.setState({ selectedRoads: roads });

  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name),
    );
  };

  onChangeSelect = (e, group) => {
    const name = e.state;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.value,
        },
      },
      () => this.validate(group, name),
    );
  }

  onChangeAttachments = (attachments, errorMessage) => {
    const errorText = errorMessage.errorText;
    const errorTitle = errorMessage.errorTitle;
    const showError = errorMessage.showError;
    this.setState({ attachments, errorText, errorTitle, showError });
  }

  validateField = (group, field) => {
    const checks = [];
    if (Object.keys(this.validators).indexOf(field) > -1) {
      for (const validator of this.validators[field]) {
        const check = validator(this.state[group][field]);
        if (check) checks.push(check);
      }
    }
    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};
    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }
    return errors;
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;
    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {
        const checks = this.validateField(group, field);
        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {
      const errors = this.validateGroup(group);
      newState = { errors };
    } else {
      let errors = {};
      const grupy = ["mpzpOwner", "info"];
      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }
      newState = { errors: { ...errors } };
    }
    if (newState) {
      if (callback) {
        this.setState(newState, callback);
      } else {
        this.setState(newState);
      }
    }
  };

  validateAttachmentsContent = () => {
    if (this.state.attachments) {
      for (const attachment of this.state.attachments) {
        if (attachment.name.length < 1) return true;
      }
    }
    return false;
  }

  haseErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }
    return false;
  };

  insertTestData = () => {
    this.setState({
      mpzpOwner: {
        FirstName: "Patryk",
        LastName: "Testowy",
        CompanyName: null,
        AddressCity: "Warszawa",
        AddressStreet: "KEN",
        AddressNumber: "85",
        AddressFlat: "87",
        AddressZipCode: "02-797"
      },
      info: {
        zmiana_z: "qwe",
        przeznaczenie: "hehe",
        uzasadnienie: "takie tam",
      }
    });
  };

  postValidation = () => {
    const hasFieldErrors = this.haseErrors();
    if (this.state.selectedParcels.length === 0) {
      this.setState({
        errorText: 'Nie wybrano działki ewidencyjnej. Prosimy o wskazanie działki',
        errorTitle: 'Błędnie wypełniony formularz',
        showError: true,
        loading: false,
      }, () => scrollToSection('CustomizedMapScroll'));
      return;
    }

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!this.state.attachments || this.state.attachments.length === 0) {
      this.setState({
        errorText: 'Wymagane jest dodanie załączników do składanego wniosku',
        errorTitle: 'Brak załączników.',
        showError: true,
        loading: false,
      });
      return;
    }

    const hasEmptyAttachment = this.validateAttachmentsContent();
    if (hasEmptyAttachment) {
      this.setState({
        errorText: 'Przynajmniej jeden załącznik jest pusty. Dodaj plik do załączników',
        errorTitle: 'Pusty załącznik.',
        showError: true,
        loading: false,
      });
      return;
    }

    if (!hasFieldErrors && this.state.selectedParcels.length > 0) {
      this.props
        .runService(this.props.serviceInfo.eservice.shortName, this.props.district, {
          mpzpOwner: { ...this.state.mpzpOwner },
          info: { ...this.state.info },
          dzialki: this.state.selectedParcels,
          selectedParcels: this.state.selectedParcels,
          user: {
            ...this.props.serviceInfo.user,
          },
          shortName: this.props.serviceInfo.eservice.shortName,
          urzad: this.props.districts[this.props.prefix],
          attachments: this.state.attachments,
        })
        .then(resp => {
          this.setState({
            loading: false }, () =>
            this.redirectToSummary(resp.jobId));
        });
    }
  };

  redirectToSummary = (jobId) => {
    window.location.href = `${this.nextStep}${jobId}`;
  };

  startService = () => {
    this.validate(null, null, this.postValidation);
  };

  render() {
    const isMobile = this.state.isMounted && isMobileView(window);
    const isTablet = this.state.isMounted && isTabletView(window);
    return (
      <div style={{ paddingTop: '20px' }}>
        <h3 style={{ textAlign: 'center' }}>
          {this.props.serviceInfo.eservice.title}
        </h3>
        <PersonalDataContainer userData={this.props.serviceInfo.user} />

        <GrayPanel
          title={'1. Teren'}
        >
          { renderHelpDesc(isMobile, isTablet) }
          <div id='CustomizedMapScroll'></div>
          <CustomizedMap
            serviceType={this.props.serviceInfo.eservice.shortName}
            setParcels={this.setParcels}
            setSelectDzialki={this.setSelectDzialki}
            selectedParcels={this.state.selectedParcels}
            obreby={this.props.serviceInfo.precints}
            district={this.props.districts[this.props.prefix]}
            prefix={this.props.prefix}
            mapState={this.props.mapstates[0]}
            settings={this.props.serviceInfo.eservice.mapConfig}
            dokumentType={this.props.serviceInfo.eservice}
          />
        </GrayPanel>
        {this.state.eserviceDistrict && this.state.eserviceDistrict.enableAgent ?
          <DecisionContainer
            title={'Pełnomocnik'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentInfoDict}
            onChange={e => this.onChange(e, 'info')}
            onChangeSelect={e => this.onChangeSelect(e, 'info')}
          >
            <br />
            <p style={{ fontWeight: 'bold' }}>
            W przypadku złożenia pełnomocnictwa należy uiścić opłatę skarbową w wysokości 17 zł.
            </p>
          </DecisionContainer> : null }
        {this.state.info.agentAdd === 'TAK' ?
          <DecisionContainer
            title={'Dane identyfikacyjne pełnomocnika'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={agentConfig.agentDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null }
        {!['gmina_olesno_powiat_oleski'].includes(this.props.prefix) && this.state.eserviceDistrict && !this.state.eserviceDistrict.custom ?
          <DecisionContainer
            title={'Właściciel'}
            data={this.state.mpzpOwner}
            errors={this.state.errors}
            formDict={mpzpOwnerDict}
            onChange={e => this.onChange(e, 'mpzpOwner')}
          /> : null }

        {this.state.eserviceDistrict && this.state.eserviceDistrict.custom ?
          <DecisionContainer
            title={'Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={customInfoDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null}
        {this.props.prefix === 'hrubieszow' ?
          <DecisionContainer
            title={'Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={infoDict2}
            onChange={e => this.onChange(e, 'info')}
          /> : null
          }
        {this.props.prefix === 'gmina_olesno_powiat_oleski' ?
          <DecisionContainer
            title={'Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={infoDict3}
            onChange={e => this.onChange(e, 'info')}
          /> : null
          }

        {!['gmina_olesno_powiat_oleski', 'hrubieszow'].includes(this.props.prefix) && this.state.eserviceDistrict && !this.state.eserviceDistrict.custom ?
          <DecisionContainer
            title={'Informacje'}
            data={this.state.info}
            errors={this.state.errors}
            formDict={infoDict}
            onChange={e => this.onChange(e, 'info')}
          /> : null
          }

        <GrayPanel title={'Informacje dla wnioskodawcy'}>
          <div className="row">
            <div className="com-sm-12">
              <p><b>Do niniejszego wniosku należy dołączyć załączniki:</b></p>
              <p>- kopia mapy, na której zaznaczono teren objęty wnioskiem</p>
            </div>
          </div>
        </GrayPanel>

        <RodoContent prefix={this.props.prefix} />

        <AttachmentsPanel onChangeAttachments={this.onChangeAttachments} showExtraText={this.props.districts[this.props.prefix].attachmentsToEpuapEnabled}/>

        <ModalAlert
          title={this.state.errorTitle}
          bodyText={this.state.errorText}
          show={this.state.showError}
          name="errorModal"
          onHide={this.onHide}
        />
        <ModalAlert
          title={loadingData.loadingTitle}
          bodyText={loadingData.loadingBody}
          show={this.state.loading}
          name="loadingModal"
          onHide={this.onHide}
          disableButton
        />

        {/* BUTTONS */}
        <div className="row mobile-row">
          <div className="col-sm-12">
            <PowrotDoListyEuslug position="left" prefix={this.props.prefix} />
            <EmptyFileDownloader position="left" prefix={this.props.prefix} serviceType={this.props.serviceInfo.eservice.shortName} />
            <button
              type="submit-lg"
              className={this.props.isDisabled ? 'btn btn-primary disabled' : 'btn btn-primary'}
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={() => this.setState({ loading: true }, () => this.startService())}
            >
              Uruchom
            </button>
            {_.includes(this.props.serviceInfo.user.roles, 'superadmin') ? (
              <button
                type="submit-lg"
                className="btn btn-success"
                style={{ float: 'right', marginRight: '15px', ...btnStyle }}
                onClick={this.insertTestData}
              >
                Insert Test Data
              </button>
            ) : null}
            <button
              type="submit-lg"
              className="btn btn-default"
              style={{ float: 'right', marginRight: '15px', ...btnStyle }}
              onClick={history.goBack}
            >
              Anuluj
            </button>
          </div>
        </div>
      </div>
    );
  }
}

ZmianaMPZP.propTypes = {
  serviceInfo: PropTypes.object,
  district: PropTypes.string,
};

const mapState = state => ({
  current_service: state.eservices.current,
  districts: state.district.districts
});

const mapDispatch = {
  runService,
};

export default withStyles(pans)(
  connect(
    mapState,
    mapDispatch,
  )(ZmianaMPZP),
);



// WEBPACK FOOTER //
// src/routes/eservices/ZmianaMPZP.js